<app-alert [alertType]="'error'" (closeClick)="closeClick.emit()">
  <span>{{ errorTranslationKey | translate }} </span>

  @if (tryAgainAction) {
    <span
      data-test-id="try-again-link"
      class="underline cursor-pointer"
      (click)="tryAgainClick()"
    >
      {{ buildTranslationKey(tryAgainAdditionalTextKey ? 'tryAgainLinkWithoutDote' :  'tryAgainLinkWithDote') | translate }}
    </span>
  }

  @if (tryAgainAdditionalTextKey) {
    <span>{{ tryAgainAdditionalTextKey | translate }} </span>
  }
</app-alert>
